(function () {
  'use strict';

  const STORAGE_KEY = 'mc_wishlist';

  function getWishlist() { try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch(e) { return []; } }
  function saveWishlist(list) { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); }
  function isInWishlist(vid) { return getWishlist().some(i => String(i.variantId) === String(vid)); }
  function addToWishlist(item) { const l = getWishlist(); if (!l.some(i => String(i.variantId) === String(item.variantId))) { l.push(item); saveWishlist(l); } }
  function removeFromWishlist(vid) { saveWishlist(getWishlist().filter(i => String(i.variantId) !== String(vid))); }

  function updateHeaderBadge() {
    const count = getWishlist().length;
    let badge = document.querySelector('.wishlist-header-badge');
    if (!badge) {
      const link = document.querySelector('.header__icon--wishlist');
      if (!link) return;
      badge = document.createElement('div');
      badge.className = 'cart-count-bubble wishlist-header-badge';
      link.appendChild(badge);
    }
    badge.innerHTML = count > 0 ? '<span aria-hidden="true">' + count + '</span>' : '';
    badge.style.display = count > 0 ? '' : 'none';
  }

  function syncHeartButtons() {
    document.querySelectorAll('.wishlist-heart-card, .wishlist-heart-product, .wishlist-heart').forEach(function(btn) {
      const vid = btn.dataset.variantId;
      if (!vid) return;
      const active = isInWishlist(vid);
      btn.classList.toggle('wishlist-active', active);
      btn.setAttribute('aria-label', active ? 'Verwijder uit verlanglijst' : 'Toevoegen aan verlanglijst');
    });
  }

  function showRemoveConfirm(onConfirm) {
    const existing = document.getElementById('wl-confirm-dialog');
    if (existing) existing.remove();
    const overlay = document.createElement('div');
    overlay.id = 'wl-confirm-dialog';
    overlay.innerHTML =
      '<div class="wl-confirm-box">'
      + '<p class="wl-confirm-text">Weet je zeker dat je dit product van je verlanglijst wil halen?</p>'
      + '<div class="wl-confirm-buttons">'
      + '<button class="button wl-confirm-yes" type="button">Ja, verwijder</button>'
      + '<button class="button button--secondary wl-confirm-no" type="button">Annuleren</button>'
      + '</div></div>';
    document.body.appendChild(overlay);
    overlay.querySelector('.wl-confirm-yes').addEventListener('click', function() { overlay.remove(); onConfirm(); });
    overlay.querySelector('.wl-confirm-no').addEventListener('click', function() { overlay.remove(); });
    overlay.addEventListener('click', function(e) { if (e.target === overlay) overlay.remove(); });
  }

  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.wishlist-heart-card, .wishlist-heart-product, .wishlist-heart');
    if (!btn) return;
    if (btn.classList.contains('wishlist-card-heart')) return;
    e.preventDefault();
    e.stopPropagation();
    let variantId = btn.dataset.variantId;
    if (!variantId) {
      const idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (idInput) variantId = idInput.value;
    }
    if (!variantId) return;
    if (isInWishlist(variantId)) {
      removeFromWishlist(variantId);
    } else {
      addToWishlist({
        productId: btn.dataset.productId || '',
        variantId: variantId,
        handle: btn.dataset.productHandle || '',
        title: btn.dataset.productTitle || '',
        variantTitle: btn.dataset.variantTitle || '',
        image: btn.dataset.productImage || '',
        price: btn.dataset.productPrice || ''
      });
    }
    syncHeartButtons();
    updateHeaderBadge();
  });

  function watchVariantChanges() {
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    const idInput = form.querySelector('[name="id"]');
    if (!idInput) return;
    const btn = document.getElementById('wishlist-button');
    if (!btn) return;
    function refresh() {
      const vid = String(idInput.value);
      btn.dataset.variantId = vid;
      const meta = window.productVariantsMeta && window.productVariantsMeta[vid];
      if (meta) {
        if (meta.title)  btn.dataset.productTitle  = meta.title;
        if (meta.handle) btn.dataset.productHandle = meta.handle;
        if (meta.vtitle) btn.dataset.variantTitle  = meta.vtitle;
        if (meta.image)  btn.dataset.productImage  = meta.image;
        if (meta.price != null) btn.dataset.productPrice = String(meta.price);
      }
      syncHeartButtons();
    }
    new MutationObserver(refresh).observe(idInput, { attributes: true, attributeFilter: ['value'] });
    refresh();
  }

  /* ── Cart drawer ──────────────────────────────────────────── */
  function refreshCartDrawer() {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => { publish(PUB_SUB_EVENTS.cartUpdate, { cart: cart }); })
        .catch(() => {});
      return;
    }
    const sectionsUrl = window.location.pathname + '?sections=cart-drawer,cart-icon-bubble';
    fetch(sectionsUrl)
      .then(r => r.json())
      .then(sections => {
        const bubbleEl = document.getElementById('cart-icon-bubble');
        if (bubbleEl && sections['cart-icon-bubble']) {
          const parsed = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
          const inner = parsed.querySelector('.shopify-section');
          if (inner) bubbleEl.innerHTML = inner.innerHTML;
        }
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents({ sections: sections, id: null });
        }
      })
      .catch(() => {});
  }

  function doAddToCart(variantId, btn, label) {
    btn.disabled = true;
    btn.textContent = 'Toevoegen...';
    const cart = document.querySelector('cart-drawer');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        sections: ['cart-drawer', 'cart-icon-bubble']
      })
    })
    .then(response => response.json())
    .then(response => {
      if (response.status) { btn.textContent = 'Niet beschikbaar'; btn.disabled = false; return; }
      if (!cart) return;
      cart.classList.remove('is-empty');
      const cartDrawerItems = cart.querySelector('cart-drawer-items');
      if (cartDrawerItems) cartDrawerItems.classList.remove('is-empty');
      cart.renderContents(response);
      cart.open();
      btn.textContent = label + ' ✓';
      setTimeout(() => { btn.textContent = label; btn.disabled = false; }, 2500);
    })
    .catch(error => { console.error(error); btn.textContent = 'Fout'; btn.disabled = false; });
  }

  document.addEventListener('click', function(e) {
    const atcBtn = e.target.closest('.wishlist-atc-btn');
    if (!atcBtn) return;
    e.preventDefault();
    e.stopPropagation();
    doAddToCart(atcBtn.dataset.variantId, atcBtn, 'In winkelwagen');
  });

  function heartSvg() {
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" class="wl-heart-svg">'
      + '<path d="M12 21.593c-5.63-5.539-11-10.297-11-14.402C1 3.742 3.766 2 6.5 2c1.987 0 3.867.918 5.5 2.834C13.633 2.918 15.513 2 17.5 2 20.234 2 23 3.742 23 7.191c0 4.105-5.37 8.863-11 14.402z" fill="currentColor"/>'
      + '</svg>';
  }

  function escHtml(s) { return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function formatMoney(c) { if (!c) return ''; return '€' + (parseInt(c, 10) / 100).toFixed(2).replace('.', ','); }

  function renderWishlistPage() {
    const container = document.getElementById('wishlist-page-container');
    if (!container) return;
    const list = getWishlist();
    if (list.length === 0) {
      container.innerHTML = '<p class="wishlist-empty">Je verlanglijst is leeg. <a href="/">Ga verder winkelen &rarr;</a></p>';
      return;
    }

    // Header row: count + add-all button
    let html =
      '<div class="wishlist-page-header">'
      + '<p class="wishlist-count">' + list.length + ' item' + (list.length !== 1 ? 's' : '') + '</p>'
      + '<button class="button wishlist-add-all-btn" type="button">Alles in winkelwagen</button>'
      + '</div>';

    // Grid
    html += '<div class="wishlist-grid">';
    list.forEach(item => {
      const variantLabel = (item.variantTitle && item.variantTitle !== 'Default Title')
        ? '<span class="wishlist-card__variant"> &mdash; ' + escHtml(item.variantTitle) + '</span>' : '';

      // Image — heart button sits INSIDE img-wrap so it overlays top-right
      let imgContent = '<div class="wishlist-card__no-img"></div>';
      if (item.image) {
        const src = item.image.startsWith('//') ? 'https:' + item.image : item.image;
        imgContent = '<a href="/products/' + escHtml(item.handle) + '?variant=' + escHtml(item.variantId) + '" tabindex="-1">'
          + '<img src="' + escHtml(src) + '" alt="' + escHtml(item.title) + '" loading="lazy" width="400" height="400">'
          + '</a>';
      }

      html +=
        '<div class="wishlist-card">'
          + '<div class="wishlist-card__img-wrap">'
            + imgContent
            + '<button class="wishlist-card-heart" type="button" data-variant-id="' + escHtml(item.variantId) + '" aria-label="Verwijder uit verlanglijst">'
              + heartSvg()
            + '</button>'
          + '</div>'
          + '<div class="wishlist-card__info">'
            + '<a class="wishlist-card__title" href="/products/' + escHtml(item.handle) + '?variant=' + escHtml(item.variantId) + '">'
              + escHtml(item.title) + variantLabel
            + '</a>'
            + (item.price ? '<p class="wishlist-card__price">' + formatMoney(item.price) + '</p>' : '')
            + '<div class="wishlist-card__actions">'
              + '<button class="button wishlist-atc-btn" type="button" data-variant-id="' + escHtml(item.variantId) + '">In winkelwagen</button>'
            + '</div>'
          + '</div>'
        + '</div>';
    });
    html += '</div>';
    container.innerHTML = html;

    // Wire card hearts
    container.querySelectorAll('.wishlist-card-heart').forEach(heartBtn => {
      heartBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const vid = heartBtn.dataset.variantId;
        showRemoveConfirm(function() {
          removeFromWishlist(vid);
          updateHeaderBadge();
          renderWishlistPage();
        });
      });
    });

    // Wire add-all (cart logic unchanged)
    const addAllBtn = container.querySelector('.wishlist-add-all-btn');
    if (addAllBtn) {
      addAllBtn.addEventListener('click', function() {
        const items = getWishlist();
        if (!items.length) return;
        addAllBtn.disabled = true;
        addAllBtn.textContent = 'Bezig...';
        let chain = Promise.resolve();
        items.forEach(item => {
          chain = chain.then(() =>
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({ id: parseInt(item.variantId, 10), quantity: 1 })
            }).then(r => r.json())
          );
        });
        chain.then(async () => {
          const sectionsResponse = await fetch('/?sections=cart-drawer,cart-icon-bubble');
          const sections = await sectionsResponse.json();
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            cartDrawer.classList.remove('is-empty');
            const cartDrawerItems = cartDrawer.querySelector('cart-drawer-items');
            if (cartDrawerItems) cartDrawerItems.classList.remove('is-empty');
            cartDrawer.renderContents({ sections: sections });
            cartDrawer.open();
          }
          addAllBtn.textContent = 'Alles toegevoegd ✓';
          setTimeout(() => { addAllBtn.textContent = 'Alles in winkelwagen'; addAllBtn.disabled = false; }, 2500);
        }).catch(() => { addAllBtn.textContent = 'Fout, probeer opnieuw'; addAllBtn.disabled = false; });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    updateHeaderBadge();
    syncHeartButtons();
    watchVariantChanges();
    renderWishlistPage();
  });

})();
